import { LeanFormSchema } from '../types/config-form.types';

export const AUTO_TEST_FORM: LeanFormSchema = {
  version: '1',
  id: 'auto-test',
  name: 'Auto Test',
  sections: [{
    id: 'auto-test',
    labelKey: 'autoTestTitle',
    registerTable: 'V3DeviceAutoTest',
    customContent: 'autoTest',
    fields: [],
  }],
};
